// extracted by mini-css-extract-plugin
module.exports = {"mediumImg":"content_mediumImg__xKfRN","productImg":"content_productImg__37Yjv","award":"content_award__3eW8L","center":"content_center__3yReP"};